<div class="social-share-container">
  <div class="social-share-header">
    <h1>{{'button.share' | translate}}</h1>
    <i class="icon-times" (click)="onClickClose()"></i>
  </div>
  <hr>

  <button mat-icon-button [ngClass]="[ icon ]" [shareButton]="icon" #fbBtn="shareButton" [title]="title" [url]="url"
    [description]="description" [autoSetMeta]="false" (opened)="shareReferral($event)"
    *ngFor="let icon of socialShareIcon">
    <div class="socialIcon-card">
      <img [src]="iconImage(icon)" alt="socialMedia icon" />
      <h1>{{ icon | titlecase }}</h1>
    </div>
  </button>

  <button (click)="onCopyURL()">
    <div class="socialIcon-card">
      <img src="assets/social-media-icon/link.png" alt="socialMedia icon" />
      <h1>{{ 'url' | translate}}</h1>
    </div>
  </button>

  <div class="copiedLink" *ngIf="copiedText">{{'button.copied' | translate}}</div>
</div>
